<template>
  <div ref="appbar" class="c-appbar">
    <div class="background">
      <c-modal-message v-if="open" :show.sync="open" title="Выйти из учетной записи?" @agree="$app.auth.logout()" />
      <div class="bar-container">
        <div class="top">

          <div v-if="title" class="title-page" :class="{'backroute': backroute?.length > 0}">{{ title }}</div>
        </div>
        <div class="info-align">
          <div class="user-info">
            <div class="info-wrapper">
              <div class="company-name">{{ $app.auth.user().fullName}} ({{$app.auth.user().accesses[0].role.description}})</div>
              <div class="logout-button">
                <div
                  class="open-button" @click="() => {
                    $router.push({name: 'profile'})
                  }">
                  <img class="icon" :src="profileActive ? imgListActive : imgList" alt="">
                </div>
                <div class="open-button" @click="open = true">
                  <img class="icon" :src="imgLogout" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgLogout from 'assets/logout-icon.svg'
import imgListActive from 'assets/profile-icon.svg'
import imgList from 'assets/profile-icon-inactive.svg'
import CModalMessage from '../modal-message/Index.vue'
import imgBack from 'assets/back-row-icon.svg'

export default {
  name: 'CAppbar',
  components: { CModalMessage, },
  props: {
    title: {
      type: String,
      default: '',
    },
    doRedirect: {
      type: Boolean,
      default: true,
    },
    showBackByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgLogout,
      imgList,
      imgListActive,
      imgBack,
      open: false,
      user: {},
      profileActive: false,
    }
  },
  computed: {
    route() {
      return this.$route.name
    },
    backroute() {
      return $app.router.current()?.route.backroute
    },
  },
  watch: {
    route() {
      this.profileActive = this.route === 'profile'
    },
  },
  created() {
    this.profileActive = this.route === 'profile'

  },
  methods: {
    redirect() {
      if (this.doRedirect) {
        this.$router.push({ name: this.backroute, })
      } else {
        this.$emit('back')
      }
    },
    getCompany() {
      // this.$var('load', true)
      // const query = 'with[company][with][settings]&with[company][with][integrations]'
      // $api.auth.info().query(query).then((response) => {
      //   this.user = response.data.content.user
      //   $app.auth.grants(response.data.content.grants)
      //   $app.auth.user(this.user)
      // }).finally(() => {
      //   this.$var('load', false)
      // })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-appbar {
  //position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: 100;
  background: #FFFFFF;
  .company-name {
    margin-right: 15px;
    font-size: 18px;
    font-weight: 500;
    color: var(--primary);
  }

  .back-icon {
    width: 24px;
    height: 24px;
    margin-top: -2px;
    margin-right: 15px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .icon {
    width: 26px;
    height: 26px;

    &.small {
      width: 28px;
      height: 28px;
    }

    &.logout {
      width: 25px;
      height: 25px;
    }
  }

  .bar-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .background {
    padding: 10px 14px 10px 10px;
    height: 58px;
    //background: linear-gradient(180deg, var(--primary) 20%, rgba(255, 226, 254, 0) 100%);

  }

  .logout-wrapper {
    position: absolute;
    left: -240px;
    z-index: 100001;
    right: 0;
    top: calc(100% + 10px);
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    border-radius: 12px;
    box-shadow: 0 4px 4px 0 #00000040;
    .buttons {
      width: 100%;
      .button {
        border-radius: 8px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        padding: 0 10px;

        &:hover {
          background-color: #EBEBEB;
        }
        &:last-child {
          margin-bottom: 10px;
        }
        .icon-place {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          width: 36px;
          height: 36px;
        }
        .title {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }

  .top {
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .title-page {
      display: flex;
      font-size: 24px;
      font-weight: 700;
      color: #1B1A1A;
      &.backroute {
        margin-left: 15px;
      }
    }

  }

  .info-align {
    .user-info {
      border-radius: 26px;
      position: relative;

      .info-wrapper {
        width: 100%;
        min-height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logout-button {
          display: flex;
          font-size: 16px;
        }

        .open-button {
          display: flex;
          align-items: center;
          margin-right: 20px;
          svg {
            path {
              fill: var(--primary);
            }
          }
        }
        &.logout {
          margin-top: 10px;
          justify-content: center;
        }
      }

      .info {
        z-index: 10000001;
        color: #767676;
        font-size: 0.8em;
        margin-right: 20px;

        div:first-child {
          font-size: 1.2em;
          color: #000000;
        }
      }
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .link {
      margin-right: 20px;
      margin-bottom: 5px;
      color: #000000;
      cursor: pointer;
      flex-shrink: 0;
      min-width: 125px;
      padding: 5px;
      min-height: 40px;
      font-size: 1em;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 3px solid var(--primary);
      border-radius: 24px;
      background-color: #FFFFFF;
      &.active {
        color: #ffffff;
        background-color: var(--primary);
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
